import {
  initialState,
  Actions,
  State,
  DELETE_ACTIVITY,
  DELETE_ACTIVITY_SUCCESS,
  DELETE_ACTIVITY_ERROR,
  RESET_DELETE_ACTIVITY,
} from "../../types/activity/delete";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_ACTIVITY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_ACTIVITY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_ACTIVITY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_ACTIVITY:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
